import { AbstractControl } from '@angular/forms';

export const ValidatorOnlyNumber = (control: AbstractControl) => {
    if (control.value === null || control.value === '') {
        return null;
    }

    if (!control.value.toString().match(/^[0-9]+(\.?[0-9]+)?$/)) {
        return { numberInvalid: true };
    }

    return null;
};
